import { FeatureFlag } from '../constants/featureFlags';
import { useStore } from '../store';
import { useAdvancedReportingEnabled } from './useAdvancedReportingEnabled';

// Report widgets and custom dashboard tabs: advanced reporting plus the
// custom-dashboard WorkOS flag.
export function useCustomDashboardEnabled(): boolean {
  const advancedEnabled = useAdvancedReportingEnabled();
  // Subscribe to the derived boolean, not the stable hasFeatureFlag fn (see
  // useAdvancedReportingEnabled).
  const customDashboard = useStore(state =>
    state.hasFeatureFlag(FeatureFlag.CUSTOM_DASHBOARD, 'workos')
  );
  return advancedEnabled && customDashboard;
}
